import React from 'react';
import { ReactComponent as FigSave01Component } from './FigSave01.svg';

const FigSave01 = (props) => <FigSave01Component {...props} />;

export default FigSave01;
